import { useState, useEffect, useRef } from "react";
import './Cooldowns.css';

function Cooldowns({ cooldowns, removeCooldowns }) {
    const [isRunning, setIsRunning] = useState(true);
    const startTimeRef = useRef(Date.now());
    const [cooldownList, setCooldownList] = useState([]);

    const [now, setNow] = useState(0);

    useEffect(() => {
        if (cooldowns.length > 0) {
            const interval = setInterval(() => {
                const curTime = Date.now();
                setNow(curTime);
                const timeout = cooldowns.filter(e => { return ((e.createdAt + e.time) < curTime) }).length;
                if (timeout > 0) {
                    removeCooldowns(curTime);
                }
            }, 1000);
            return () => clearInterval(interval);
        }
    }, [cooldowns]);

    // Calculate percentage of time remaining for visual indicator
    const getTimeLeftPercentage = (cooldown) => {
        if (!now) return 100;
        const elapsed = now - cooldown.createdAt;
        const percentage = 100 - (elapsed / cooldown.time * 100);
        return Math.max(0, Math.min(100, percentage));
    };

    return (
        <div className="cd-bar">
            {cooldowns.map(e => {
                // Calculate remaining time
                const remaining = e.time - (now - e.createdAt);
                // Only show positive durations
                if (remaining > 0) {
                    const percentLeft = getTimeLeftPercentage(e);
                    return (
                        <p key={e.name} className={percentLeft < 20 ? "expiring" : ""}>
                            <div 
                                className="cooldown-progress" 
                                style={{ width: `${percentLeft}%` }}
                            ></div>
                            <span className="cooldown-name">{e.name}:</span>
                            <span className="cooldown-time">{msToTime(remaining)}</span>
                        </p>
                    );
                }
                return null;
            }).filter(Boolean)}
        </div>
    );
}

function msToTime(duration) {
    // Ensure duration is positive
    duration = Math.max(0, duration);
    
    var milliseconds = Math.floor((duration % 1000) / 100),
        seconds = Math.floor((duration / 1000) % 60),
        minutes = Math.floor((duration / (1000 * 60)) % 60);
    seconds = (seconds < 10) ? "0" + seconds : seconds;
    if(minutes > 0) {
        return minutes + "m" + seconds + "s";
    } else {
        return seconds + "s";
    }
}

export default Cooldowns;